import { render } from "./ConfirmMessage.vue?vue&type=template&id=2db189af&scoped=true"
import script from "./ConfirmMessage.vue?vue&type=script&lang=js"
export * from "./ConfirmMessage.vue?vue&type=script&lang=js"

import "./ConfirmMessage.vue?vue&type=style&index=0&id=2db189af&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db189af"]])

export default __exports__